import * as React from "react";
import {TextInput} from "./TextInput";

/**
 * Password Input Element
 */
export class PasswordInput extends TextInput {

    type: any = 'password';

}